(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sumeo-serum-landing"] && !Shopify.designMode) return;
  try {
    

function syncSerumHeaderHeight() {
  const hero = document.querySelector('.sl-photo-hero');
  const header = document.querySelector('.shopify-section-header');
  if (!hero || !header) return;
  const update = () => {
    const height = header.getBoundingClientRect().height;
    if (height > 0) document.body.style.setProperty('--sl-header-height', height + 'px');
  };
  update();
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(header);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSerumHeaderHeight, { once: true });
else syncSerumHeaderHeight();

document.addEventListener('submit', async function(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.sl-form')) return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('.sl-error');
  const label = button.textContent;
  const data = new FormData(form);
  const items = [0, 1].map(i => ({id: Number(data.get(`items[${i}][id]`)), quantity: Number(data.get(`items[${i}][quantity]`))}));
  form.dataset.pending = 'true';
  form.setAttribute('aria-busy', 'true');
  button.disabled = true;
  button.textContent = form.dataset.busy;
  error.hidden = true;
  try {
    const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items}), credentials:'same-origin'});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
    window.location.assign(data.get('return_to'));
  } catch (issue) {
    error.textContent = issue instanceof Error && issue.message !== 'Failed to fetch' ? issue.message : form.dataset.error;
    error.hidden = false;
    button.disabled = false;
    button.textContent = label;
    form.dataset.pending = 'false';
    form.removeAttribute('aria-busy');
  }
});


  } catch(e) { console.error(e); }
})();
})();
